<template>
  <v-card
    class="d-flex align-center item-odds item-inplay-odds"
    dense
    flat
    tile
    height="45"
  >
    <v-btn
      text
      tile
      color="white"
      class="odds-detail px-2 text-capitalize caption font-weight-bold flex-grow-1 flex-shrink-1"
      v-bind="$attrs"
      @click="delay()"
      v-on="$listeners"
    >
      <div
        class="mx-0 px-0 py-0 my-0"
        :class="$breakpoint.smAndUp ? 'col-7' : 'col-8'"
      >
        <span
          v-if="
            market &&
            market.market &&
            market.market.start &&
            getTitle(market.market.start)
          "
          class="float-left px-2 calendar-space primary--text"
          style="height: 28px"
        >
          {{ getTitle(market.market.start) }}
        </span>
        <template v-for="(i, key) in [0, 1]">
          <span
            v-if="market && market.players && market.players.length > 0"
            :key="key"
            class="d-block black--text manage-overflow text-position"
            :class="{ 'manage-overflow-sm': $breakpoint.smAndDown }"
            style="text-align: left"
          >
            {{
              market.players &&
              market.players[i] &&
              market.players[i].name &&
              market.players[i].name
            }}
          </span>
        </template>
      </div>
      <div
        class="mx-0 px-0 py-0 my-0 d-flex align-items-center justify-end"
        :class="$breakpoint.smAndUp ? 'col-5' : 'col-4'"
      >
        <div
          class="col-4 mx-0 px-0 py-0 my-2 text-center"
          :class="{
            'pr-0': $breakpoint.smAndDown,
            'pr-1': $breakpoint.smAndUp
          }"
        >
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <span v-show="tv && !showDate">
                <span
                  :class="{
                    'pa-0 d-flex': $breakpoint.smAndDown,
                    'px-1 d-inline': $breakpoint.smAndUp
                  }"
                  v-bind="attrs"
                  class="justify-center ma-0 green--text live-ico inplay-ico"
                  v-on="on"
                >
                  <v-icon
                    class="green--text"
                    :size="$breakpoint.smAndUp ? 18 : 14"
                  >
                    mdi-play
                  </v-icon>
                </span>
              </span>
            </template>
            <span>In-Play</span>
          </v-tooltip>
        </div>
        <div
          class="col-4 mx-0 px-0 py-0 my-2 text-center"
          :class="{
            'pr-0': $breakpoint.smAndDown,
            'pr-1': $breakpoint.smAndUp
          }"
        >
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <span
                v-if="inplayIcon && !showDate"
                class="justify-center green--text live-ico"
                :class="{
                  'pa-0 d-flex': $breakpoint.smAndDown,
                  'px-1 d-inline': $breakpoint.smAndUp
                }"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon :size="$breakpoint.smAndUp ? 16 : 14" color="green">
                  mdi-access-point
                </v-icon>
              </span>
            </template>
            <span>LIVE</span>
          </v-tooltip>
        </div>
        <div
          class="col-4 mx-0 px-0 py-0 text-center"
          :class="{
            'pr-0 my-2': $breakpoint.smAndDown,
            'pr-1 my-1': $breakpoint.smAndUp
          }"
        >
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <span
                v-show="market.threeETId"
                class="black--text premium-ico text-center"
                v-bind="attrs"
                v-on="on"
              >
                <v-btn
                  icon
                  color="amber"
                  class="justify-center mdi-crown pa-0"
                  style="width: auto; height: auto"
                  :to="
                    market &&
                    market.eventTypeId &&
                    market.market &&
                    market.market.market &&
                    market.market.market.id &&
                    market.event &&
                    market.event.id &&
                    `/sportsbook/${market.eventTypeId}/${market.market.market.id}/${market.event.id}`
                  "
                >
                  <v-icon :size="$breakpoint.smAndUp ? 20 : 16"
                    >mdi-crown</v-icon
                  >
                </v-btn>
              </span>
            </template>
            <span>PREMIUM</span>
          </v-tooltip>
        </div>
      </div>
    </v-btn>

    <odds-disabled
      v-if="checkIfSuspended(market)"
      :text="checkIfSuspended(market)"
      three-btn
      v-bind="$attrs"
      v-on="$listeners"
    ></odds-disabled>

    <template
      v-for="(i, key) in market.eventType === 'Cricket' ||
      market.eventType === 'Tennis'
        ? [0, 1, 2]
        : [0, 2, 1]"
    >
      <btn-odds
        v-if="
          betfairOddsCheck(market) &&
          (!$auth.user ||
            !(
              market.eventType === 'Cricket' &&
              $auth.user &&
              !$auth.user.matchOdds &&
              market.name &&
              market.name.toLowerCase() === 'match odds'
            ))
        "
        :key="'back' + key"
        type="back"
        :disabled="
          !check(
            marketSocket,
            'back',
            i
            // getRateIndex('back', market.bookMakerCustom)
          )
        "
        v-bind="$attrs"
        v-on="$listeners"
        @betData="
          delay()
          $store.commit('placeBet/openPopoverInplay', {
            event: fakeEvent,
            market: fakeEvent,
            runner: fakeEvent.runners[i],
            allRunners: fakeEvent.runners,
            oddsIndex: i,
            odds: {
              price: fakeEvent.runners[i].back.price,
              index: i,
              type: 'back'
            },
            type: 'back',
            bettingType:
              market.bookMakerCustom && market.isJodiMarket
                ? 'multiHorse'
                : market.bookMakerCustom && !market.isJodiMarket
                ? 'bookmaker'
                : 'default'
          })
        "
      >
        <span
          v-if="!check(marketSocket, 'back', i)"
          class="d-block text-center"
          style="font-weight: 800 !important"
        >
          -
        </span>
        <span v-else class="d-block text-center">
          {{ marketSocket.back[i].price }}
          <span class="d-block text-center text-lowercase mini-rate">
            <span
              v-if="
                marketSocket &&
                marketSocket.back &&
                marketSocket.back[i] &&
                marketSocket.back[i].size < 1000000 &&
                marketSocket.back[i].size * (multiplayer || 1)
              "
            >
              {{
                (marketSocket.back[i].size * (multiplayer || 1))
                  | currencyFormat(0)
              }}
            </span>
            <span
              v-else-if="
                marketSocket &&
                marketSocket.back &&
                marketSocket.back[i] &&
                marketSocket.back[i].size > 1000000 &&
                marketSocket.back[i].size * (multiplayer || 1)
              "
            >
              1cr+
            </span>
            <span v-else>
              <span v-if="marketSocket.back[i].size">
                {{
                  marketSocket.back[i].size === 0
                    ? null
                    : marketSocket.back[i].size | currencyFormat(0)
                }}
              </span>
            </span>
          </span>
        </span>
      </btn-odds>

      <btn-odds
        v-if="
          showLay &&
          $breakpoint.smAndUp &&
          betfairOddsCheck(market) &&
          (!$auth.user ||
            !(
              market.eventType.name === 'Cricket' &&
              $auth.user &&
              !$auth.user.matchOdds &&
              market.name &&
              market.name.toLowerCase() === 'match odds'
            ))
        "
        :key="'lay' + key"
        type="lay"
        :disabled="!check(marketSocket, 'lay', i)"
        v-bind="$attrs"
        v-on="$listeners"
        @betData="
          delay()
          $store.commit('placeBet/openPopoverInplay', {
            event: fakeEvent,
            market: fakeEvent,
            runner: fakeEvent.runners[i],
            allRunners: fakeEvent.runners,
            oddsIndex: i,
            odds: {
              price: fakeEvent.runners[i].lay.price,
              index: i,
              type: 'lay'
            },
            type: 'lay',
            bettingType:
              market.bookMakerCustom && market.isJodiMarket
                ? 'multiHorse'
                : market.bookMakerCustom && !market.isJodiMarket
                ? 'bookmaker'
                : 'default'
          })
        "
      >
        <span v-if="!check(marketSocket, 'lay', i)" class="d-block text-center">
          -
        </span>
        <span v-else class="d-block text-center">
          {{ marketSocket.lay[i].price }}
          <span class="d-block text-center text-lowercase mini-rate">
            <span
              v-if="
                marketSocket &&
                marketSocket.lay &&
                marketSocket.lay[i] &&
                marketSocket.lay[i].size < 1000000 &&
                marketSocket.lay[i].size * (multiplayer || 1)
              "
            >
              {{
                (marketSocket.lay[i].size * (multiplayer || 1))
                  | currencyFormat(0)
              }}
            </span>
            <span
              v-else-if="
                marketSocket &&
                marketSocket.lay &&
                marketSocket.lay[i] &&
                marketSocket.lay[i].size > 1000000 &&
                marketSocket.lay[i].size * (multiplayer || 1)
              "
            >
              1cr+
            </span>
            <span v-else>
              <span v-if="marketSocket.lay[i].size">
                {{
                  marketSocket.lay[i].size === 0
                    ? null
                    : marketSocket.lay[i].size | currencyFormat(0)
                }}
              </span>
            </span>
          </span>
        </span>
      </btn-odds>
    </template>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import BtnOdds from '@/components/BtnOdds'
import OddsDisabled from '@/components/OddsDisabled'

export default {
  name: 'InplayOdds',
  components: { BtnOdds, OddsDisabled },
  props: {
    market: { type: Object, default: () => {}, required: true },
    tv: { type: Boolean, default: false, required: false },
    showDate: { type: Boolean, default: false, required: false },
    inplayIcon: { type: Boolean, default: true, required: false },
    showLay: { type: Boolean, default: true, required: false }
  },

  data() {
    return {
      marketSocket: {},
      fakeEvent: {
        id: `${this.market.market.id}`,
        groupById: `${this.market.market.groupById}`,
        name: `${this.market.market.name}`,
        btype: `${this.market.market.btype}`,
        event: this.market.market.event,
        eventTypeId: `${this.market.market.eventTypeId}`,
        inPlay: this.market.market.inPlay,
        competition: this.market.market.competition,
        matched: this.market.market.matched,
        status: `${this.market.market.status}`,
        runners: [
          {
            id: this.market?.market?.consolidatedRunner?.back[0]?.runner?.id,
            name: `${this?.market?.market?.consolidatedRunner?.back[0]?.runner?.name}`,
            back: this.market?.market?.consolidatedRunner?.back[0],
            lay: this.market?.market?.consolidatedRunner?.lay[0]
          },
          {
            id: this.market?.market?.consolidatedRunner?.back[1]?.runner?.id,
            name: `${this.market?.market?.consolidatedRunner?.back[1]?.runner?.name}`,
            back: this.market?.market?.consolidatedRunner?.back[1],
            lay: this.market?.market?.consolidatedRunner?.lay[1]
          },
          {
            id: this.market?.market?.consolidatedRunner?.back[2]?.runner?.id,
            name: `${this.market?.market?.consolidatedRunner?.back[2]?.runner?.name}`,
            back: this.market?.market?.consolidatedRunner?.back[2],
            lay: this.market?.market?.consolidatedRunner?.lay[2]
          }
        ],
        betDelay: this.market.market.betDelay,
        isBettable: this.market.market.isBettable
      }
    }
  },
  computed: {
    ...mapState({
      balanceSettings: (state) => state.settings.balanceSettings
    }),
    multiplayer() {
      return this.balanceSettings?.settings[this.market?.eventTypeId]
        ?.volumeMultiplier
    }
  },
  watch: {
    market() {
      this.marketSocket = this.market?.market?.consolidatedRunner
    }
  },
  created() {
    if (this.market && this.market?.market?.consolidatedRunner) {
      this.marketSocket = this.market?.market?.consolidatedRunner
    }
  },
  beforeDestroy() {},
  methods: {
    getTitle(startTime) {
      const fixturedate = this.$moment(startTime)
      if (this.showDate) {
        if (this.$moment().isSame(this.$moment(fixturedate), 'week')) {
          return this.$moment(fixturedate).calendar()
        } else {
          return this.$moment(fixturedate).format('ddd, DD/MM hh:mm A')
        }
      } else {
        return false
      }
    },
    getRateIndex(type, bookmaker) {
      if (type === 'lay' && bookmaker) {
        return 0
      } else if (type === 'back' && bookmaker) {
        return 2
      } else {
        return 1
      }
    },
    check(runner, key, i, j) {
      const result =
        runner && runner[key] && runner[key][i] && !!runner[key][i]?.price
      return result
    },
    async delay() {
      await this.$store.dispatch('matchInside/getScoreCardId', {
        eventTypeId: this.market.eventTypeId,
        eventId: this.market.event.id
      })
      setTimeout(() => {
        this.$router.push(
          `/sportsbook/${this.market?.eventTypeId}/${this.market?.market?.competition?.id}/${this.market?.event?.id}`
        )
      }, 400)
    }
  }
}
</script>
<style scoped>
.float-top-right {
  position: absolute !important;
  top: 0;
  right: 0;
}
.calendar-space {
  height: 28px;
  width: 60px;
  white-space: normal;
  font-size: 9px;
  text-align: right;
  font-weight: normal;
  padding-left: 0 !important;
  margin-left: -5px;
}
.text-position {
  text-align: start;
}
.v-btn {
  border-radius: 0.4rem;
}
@media only screen and (max-width: 712px) {
  .v-btn--icon.v-size--default {
    width: auto;
    height: auto;
  }
  .v-btn--icon.v-size--default .v-icon,
  .v-btn--fab.v-size--default .v-icon {
    height: 18px;
    font-size: 18px;
    width: 18px;
  }
}
</style>
